import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  LabelStyled,
  TextStyled,
} from "../../../styled/Elements";
import { Form, Modal } from "react-bootstrap";
import ValidatedInput from "../../../common/inputFields/ValidatedInput";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import ValidationController from "../../../common/inputFields/ValidationController";

const ReasonModal = ({
  show,
  onHide,
  onChange,
  acceptRejectRequest,
  requestId,
  reason,
}) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    acceptRejectRequest(requestId, 2, data.reason);
    onHide();
    reset();
  };
  return (
    <Modal show={show} onHide={onHide} centered>
      <ReasonModalWrapper>
        <Box className="p-4">
          <Box className="mb-4">
            <Box>
              <HeadingStyled size="24px" weight="bold" color="var(--text)">
                {t("rejection_reason")}
              </HeadingStyled>
              <TextStyled size="16px" color="var(--text2)">
                {t("enter_reason_to_reject")}
              </TextStyled>
            </Box>
          </Box>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Box className="d-flex gap-3 gap-md-5">
              <LabelStyled size="16px" color="var(--text)" className="mt-3">
                {t("reason")}
              </LabelStyled>
              <ValidationController
                name="reason"
                validationConfig={{
                  required: true,
                }}
                errors={errors}
                control={control}
                className="w-100"
                renderer={({ field }) => (
                  <ValidatedInput
                    // label={t("reason")}
                    onChange={(e) => {
                      onChange(e);
                      field.onChange(e.target.value);
                    }}
                    name={"reason"}
                    type={"textarea"}
                    fieldType={"text"}
                    placeholder={t("type_here")}
                    className={"border-0 p-0"}
                  />
                )}
              />
            </Box>
            <Box className="d-flex justify-content-end">
              <Box className="mt-4 d-flex gap-3">
                <ButtonStyled
                  label={t("Cancel")}
                  bg={"var(--bgSecondary)"}
                  color={"var(--text2)"}
                  onClick={onHide}
                />
                <ButtonStyled
                  // onClick={() => {
                  //   acceptRejectRequest(requestId, 2, reason);
                  //   reason && onHide();
                  // }}
                  type="submit"
                  label={t("reject")}
                />
              </Box>
            </Box>
          </Form>
        </Box>
      </ReasonModalWrapper>
    </Modal>
  );
};

export default ReasonModal;

const ReasonModalWrapper = styled.div``;
